module.exports = __webpack_public_path__ + "img/725.10abfcc7.gif";